import { DataBean } from "../DataBean";

export class setBanking extends DataBean {


    public async setBankingConciliationLeft(idBankingConciliation:any,bankingLeft:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_setBankingConciliationLeft_Number_Number", [idBankingConciliation,bankingLeft]);
    }

}